import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'semantic-ui-react';

import styles from './styles';

const Home = () => (
  <div style={styles.container}>
    <h2>Que base você deseja pesquisar?</h2>
    <Link to="/search">
      <Button primary className="shadowed" style={styles.button}>
        Ministério da Educação
      </Button>
    </Link>
    <Button disabled style={styles.button}>
      Ministério da Agricultura
    </Button>
    <Button disabled style={styles.button}>
      Ministério da Fazenda
    </Button>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/Home.js